/**
 *
 * CustomInputText
 *
 */
import React, { memo, useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';
import './assets/css/styles.css';
import { Form, Input, InputProps, Select } from 'antd';

interface Props extends InputProps {
  nameInput: string;
  label: string;
  required: boolean;
  errorMessage?: string;
  type?: string;
  placeholder?: string;
  readOnly?: boolean;
}

export const CustomInputText = memo((props: Props) => {
  const { nameInput, label, required, errorMessage, placeholder, readOnly = false, type = 'text', ...rest } = props;

  const [help, setHelp] = useState<string>('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === 'email' && e.target.value.length > 5) {
      const regex =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

      if (!regex.test(e.target.value)) {
        setHelp('Adresse email invalide.');
      } else {
        setHelp('');
      }
    }
  };

  return (
    <Div>
      <Form.Item
        name={nameInput}
        label={label}
        validateStatus={help!.length > 0 ? 'error' : undefined}
        help={help}
        rules={[
          {
            required: required,
            message: (
              <div style={{ marginTop: '4px' }} className="d-flex align-items-center">
                <ErrorRoundedIcon
                  style={{
                    color: '#ff0000',
                    fontSize: '16px',
                    marginRight: '4px',
                  }}
                />
                {errorMessage}
              </div>
            ),
          },
        ]}
        className="form-input"
      >
        <Input
          readOnly={readOnly}
          placeholder={placeholder}
          type={type}
          onChange={onChange}
          className="input-text"
          {...rest}
        />
      </Form.Item>
    </Div>
  );
});

const Div = styled.div``;
